import React from "react";
import logo from '../../assets/images/logo_lf_skane.svg';
// import contactIcon from '../../assets/scss/lfui/icon/src/svg/32px/contact-menu-32.svg';
import contactIcon from '../../assets/icons/contact-menu.svg';

export default class Navbar extends React.Component {

    render() {
        return (
            <div className="bg-white header-wrapper bb-2">
                <nav className="navbar lf-header pl-03 bb-0 d-md-flex justify-content-between">
                    <a data-toggle="modal" data-target="#leaveModal" className="navbar-brand p-0"
                       href="https://www.lansforsakringar.se/">
                        <img src={logo} className="d-inline-block LF-header-logo"
                             height="60px" alt=""/>
                    </a>
                    <div>
                        <ul className="nav navbar-nav d-none d-md-flex">
                            <li className="">
                                <a className="link-adaptive font-base" role="button" data-toggle="modal" data-target="#leaveModal">Till lansforsakringar.se</a>
                            </li>
                            <li className=""><a href="https://www.lansforsakringar.se/skane/foretag/om-oss/kontakta-oss/" className="link-complex font-base" role="button" target="blank">
                                <img src="" alt=""/>
                                <img src={contactIcon} className="icon icon-left"
                                     height="24px" alt=""/>

                                <span className="link-complex-adaptive-target font-base">Kontakta oss</span></a>
                            </li>
                        </ul>

                    </div>

                </nav>
                <div className="modal fade" id="leaveModal" tabIndex="-1" role="dialog" aria-labelledby="leaveModal"
                     aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close close-large" data-dismiss="modal"
                                        aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                                <h4 className="modal-title" id="myModalLabel">Varning</h4>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <p>Du kommer nu lämna tjänsten och förlora dina ifyllda uppgifter.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <a role="button" className="btn btn-primary btn-arrow" href="https://www.lansforsakringar.se/skane/foretag/">Fortsätt</a>
                                <button type="button" className="btn btn-link" data-dismiss="modal">Avbryt</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
